/**
 * 通用状态标签组件
 * 支持 running、completed、pending、failed 等状态
 */

import { FC } from 'react';
import {
  INQUIRY_TASK_STATUS_TAG_CONFIG,
  InquiryTaskStatusTagStatus,
  STATUS_TAG_CONFIG,
  StatusTagConfig,
} from './config';
import type { StatusTagProps } from './types';

export const PureStatusTag: FC<
  Pick<StatusTagProps, 'text' | 'showDot' | 'className'> & {
    config: StatusTagConfig;
  }
> = ({ text, showDot = true, className = '', config }) => {
  const displayText = text || config.text;

  return (
    <span
      className={`inline-flex items-center gap-[4px] px-[9px] py-[3px] rounded-[8px] text-[12px] font-medium leading-[16px] ${className}`}
      style={{
        backgroundColor: config.backgroundColor,
        color: config.textColor,
      }}
    >
      {showDot && (
        <span
          className="w-[6px] h-[6px] rounded-full flex-shrink-0"
          style={{
            backgroundColor: config.dotColor,
          }}
        />
      )}
      <span>{displayText}</span>
    </span>
  );
};

export const StatusTag: FC<StatusTagProps> = ({ status, text, showDot = true, className = '' }) => {
  const config = STATUS_TAG_CONFIG[status];
  const displayText = text || config.text;
  return <PureStatusTag text={displayText} showDot={showDot} className={className} config={config} />;
};
/**
 * 建联任务状态标签组件
 * @param param0
 * @returns
 */
export const InquiryTaskStatusTag: FC<Omit<StatusTagProps, 'status'> & { status: InquiryTaskStatusTagStatus }> = ({
  status,
  text,
  showDot = true,
  className = '',
}) => {
  const config = INQUIRY_TASK_STATUS_TAG_CONFIG[status];
  const displayText = text || config.text;
  return <PureStatusTag text={displayText} showDot={showDot} className={className} config={config} />;
};
